<template>
  <div v-if="remainingDetail.id" class="detail-remaining-container">
    <div class="detail-remaining-content">
      <div class="detail-header">
        <p>{{ remainingDetail.name }}</p>
        <p>{{ remainingDetail.ein }}</p>

        <table>
          <tr>
            <td>Work Unit</td>
            <td>:</td>
            <td>{{ remainingDetail.satker_name }}</td>
          </tr>
          <tr>
            <td>Position</td>
            <td>:</td>
            <td>{{ remainingDetail.position_name }}</td>
          </tr>
          <tr>
            <td>Effective Date</td>
            <td>:</td>
            <td>{{ formatDate('date', remainingDetail.start_working) }}</td>
          </tr>
        </table>
      </div>

      <div class="detail-tree">
        <div v-for="parent in remainingDetail.list_leave" :key="parent" class="detail-tree-period">
          <div class="period-header">
            {{ parent.index }}
          </div>

          <div class="detail-tree-inherit">
            <div v-for="data in parent.data" :key="data" class="parent-tree-container">
              <div class="parent-tree-content">
                <!-- <p><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b>/{{ data.max_qty }}</p> -->
                <p><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.used }}</b>/{{ data.sisa_cuti }}</p>
              </div>

              <div
                v-for="child in data.history_cuti"
                :key="child"
                class="child-tree-container"
                :class="{
                  'child-tree-yellow': (child.state == 'Waiting for Approval'),
                  'child-tree-green': (child.state == 'Approved'),
                  'child-tree-red': (child.state == 'Rejected')
                }"
              >
                <p><b>{{ formatDate('datetime', child.leave_date) }}</b></p>
                <p>{{ child.transaction }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="remainingDetail.group == 'personal'" class="detail-remaining-content" style="padding-top: 12px;">
      <div class="detail-tree">
        <div class="parent-tree-container">
          <div class="parent-tree-content">
            <p><b>{{ remainingDetail.data.leave_name }}</b> | Remaining leave balance: <b>{{ remainingDetail.data.sisa_cuti }}</b></p>
          </div>

          <div
            v-for="child in remainingDetail.data.history_cuti"
            :key="child"
            class="child-tree-container"
            :class="{
              'child-tree-yellow': (child.state == 'Waiting for Approval'),
              'child-tree-green': (child.state == 'Approved'),
              'child-tree-red': (child.state == 'Rejected')
            }"
          >
            <p><b>{{ formatDate('datetime', child.leave_date) }}</b></p>
            <p>{{ child.transaction }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <div v-if="remainingDetail.data" class="detail-remaining-container">
    <div class="detail-remaining-content">
      <div class="detail-header">
        <p>{{ remainingDetail.data.employee_name }}</p>
        <p>{{ remainingDetail.data.ein }}</p>

        <table>
          <tr>
            <td>Work Unit</td>
            <td>:</td>
            <td>{{ remainingDetail.data.work_unit }}</td>
          </tr>
          <tr>
            <td>Position</td>
            <td>:</td>
            <td>{{ remainingDetail.data.position }}</td>
          </tr>
          <tr>
            <td>Effective Date</td>
            <td>:</td>
            <td>{{ formatDate('date', remainingDetail.data.start_working) }}</td>
          </tr>
        </table>
      </div>

      <div v-if="remainingDetail.group == 'personal'" class="detail-tree">
        <div v-for="data in remainingDetail.data.list_leave" :key="data" class="parent-tree-container">
          <div class="parent-tree-content">
            <p><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b></p>
          </div>

          <div
            v-for="child in data.history_cuti"
            :key="child"
            class="child-tree-container"
            :class="{
              'child-tree-yellow': (child.state == 'Waiting for Approval'),
              'child-tree-green': (child.state == 'Approved'),
              'child-tree-red': (child.state == 'Rejected')
            }"
          >
            <!-- <p><b>{{ formatDate('datetime', child.leave_date) }}</b> ([total hari] hari) | [status cuti]</p> -->
            <p><b>{{ formatDate('datetime', child.leave_date) }}</b></p>
            <p>{{ child.transaction }}</p>
          </div>
        </div>
      </div>

      <div v-else-if="remainingDetail.group == 'all'" class="detail-tree">
        <div v-for="parent in remainingDetail.data.list_period" :key="parent" class="detail-tree-period">
          <div class="period-header">
            {{ parent.period }}
          </div>

          <div class="detail-tree-inherit">
            <div v-for="data in parent.list" :key="data" class="parent-tree-container">
              <div class="parent-tree-content">
                <p><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b></p>
              </div>

              <div
                v-for="child in data.history_cuti"
                :key="child"
                class="child-tree-container"
                :class="{
                  'child-tree-yellow': (child.state == 'Waiting for Approval'),
                  'child-tree-green': (child.state == 'Approved'),
                  'child-tree-red': (child.state == 'Rejected')
                }"
              >
                <!-- <p><b>{{ formatDate('datetime', child.leave_date) }}</b> ([total hari] hari) | [status cuti]</p> -->
                <p><b>{{ formatDate('datetime', child.leave_date) }}</b></p>
                <p>{{ child.transaction }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="remainingDetail.group == 'personal'" class="detail-remaining-content" style="padding-top: 12px;">
      <div class="detail-tree">
        <div class="parent-tree-container">
          <div class="parent-tree-content">
            <p><b>{{ remainingDetail.data.leave_name }}</b> | Remaining leave balance: <b>{{ remainingDetail.data.sisa_cuti }}</b></p>
          </div>

          <div
            v-for="child in remainingDetail.data.history_cuti"
            :key="child"
            class="child-tree-container"
            :class="{
              'child-tree-yellow': (child.state == 'Waiting for Approval'),
              'child-tree-green': (child.state == 'Approved'),
              'child-tree-red': (child.state == 'Rejected')
            }"
          >
            <p><b>{{ formatDate('datetime', child.leave_date) }}</b></p>
            <p>{{ child.transaction }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, onMounted, onBeforeMount, computed, watchEffect, reactive } from 'vue'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

  import defaultImage from '@/assets/general/usericon.png'

  export default {
    props: {
      remainingDetail: { type: Object, default: {} }
    },

    setup (props, { emit }) {
      const userRole = localStorage.getItem('roles')
      const userName = localStorage.getItem('name')
      const userEmail = localStorage.getItem('Email')
      const employeeId = localStorage.getItem('employee_id')

      const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      function formatDate(type, date) {
        const day = new Date(date).getDate()
        const month = new Date(date).getMonth()
        const year = new Date(date).getFullYear()
        const dayOfWeek = new Date(date).getDay()
        var time = ('0' + new Date(date).getHours()).slice(-2) + "." + ('0' + new Date(date).getMinutes()).slice(-2)

        // const months = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        // const days = locale.value == 'id' ? daysId : daysEn

        if(type == 'date') {
          const formattedDate = `${day} ${monthsEn[month]} ${year}`
          return formattedDate
        }
        else if(type == 'datetime') {
          const formattedDate = `${day} ${monthsEn[month]} ${year}, ${time}`
          return formattedDate
        }
      }

      return {
        formatDate
      }
    }
  }
</script>

<style lang="scss" scoped>
  .detail-remaining-container {
    width: 100%;
    height: 100%;
    padding: 8px 20px 20px 20px;
    background-color: white;
    overflow-y: auto;


    .detail-remaining-content {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;


      .detail-header {
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid lightgray;

        p {
          width: 100%;

          &:nth-child(1) {
            font-size: 20px;
            line-height: 32px;
            font-weight: 500;
          }

          &:nth-child(2) {
            font-size: 14px;
            line-height: 24px;
            font-weight: 500;
            margin-bottom: 12px;
          }
        }

        table {
          width: 100%;

          tr {
            td {
              padding: 0;
              font-size: 14px;
              line-height: 24px;
              color: gray;

              &:nth-child(1) {
                width: 120px;
              }

              &:nth-child(2) {
                width: 10px;
              }

              &:nth-child(3) {
                color: black;
                font-weight: 500;
              }
            }
          }
        }
      }


      .detail-tree {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;
        // background-color: red;

        .parent-tree-container {
          width: 100%;
          background-color: rgb(236, 250, 255);
          border-radius: 16px;
          padding: 0 12px;

          .parent-tree-content {
            width: 100%;
            padding: 8px 0;

            p {
              width: 100%;
              font-size: 14px;
              line-height: 24px;
            }
          }

          .child-tree-container {
            width: calc(100% - 32px);
            margin-left: 32px;
            position: relative;
            background-color: white;
            border: 2px solid white;
            border-radius: 12px;
            padding: 8px 12px;
            margin-bottom: 16px;

            &::before {
              content: '';
              width: 1px;
              height: calc(100% + 20px);
              position: absolute;
              top: 0;
              left: -16px;
              background-color: gray;
            }

            &::after {
              content: '';
              width: 12px;
              height: 12px;
              border-radius: 50%;
              position: absolute;
              top: 12px;
              left: -21.6px;
              background-color: gray;
            }


            &:nth-last-child(1) {
              margin-bottom: 12px;

              &::before {
                height: 24px;
              }
            }

            p {
              font-size: 14px;
              line-height: 24px;
            }
          }

          .child-tree-yellow {
            background-color: rgb(255, 250, 237);
            border: 2px solid rgb(255, 235, 184);
          }
          .child-tree-green {
            background-color: rgb(237, 255, 237);
            border: 2px solid rgb(195, 255, 195);
          }
          .child-tree-red {
            background-color: rgb(255, 237, 237);
            border: 2px solid rgb(255, 192, 185);
          }
        }


        .detail-tree-period {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 20px;

          .period-header {
            width: 100%;
            height: auto;
            text-align: left;
            font-weight: 700;
            font-size: 20px;
            line-height: 32px;
            // padding: 0 0 0 20px;
          }

          .detail-tree-inherit {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 0 0 0 40px;
            position: relative;

            .parent-tree-container {
              position: relative;

              &::before {
                content: '';
                width: 1px;
                height: calc(100% + 20px);
                position: absolute;
                top: 0;
                left: -20px;
                background-color: lightgray;
              }

              &::after {
                content: '';
                width: 16px;
                height: 16px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: -27px;
                background-color: lightgray;
              }

              &:nth-child(1) {
                &::before {
                  height: calc(100% + 20px + 20px);
                  top: -20px;
                }
              }

              &:nth-last-child(1) {
                &::before {
                  height: 50%;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
